import {PayloadAction, createSlice} from '@reduxjs/toolkit'
import {
  SubjectState,
  FetchSubjectsResponse,
  FetchSubjectByIdResponse,
  FetchAllSubjectsResponse,
} from './types'
import {
  fetchSubjectById,
  fetchSubjects,
  createSubject,
  updateSubject,
  deleteSubject,
  suspendSubject,
  activateSubject,
  fetchAllSubjects,
} from './service'
import {ResponseError} from '../commonTypes'

const initialState: SubjectState = {
  subjectForEdit: null,
  subjects: [],
  total: 0,
  totalPages: 0,
  listLoading: false,
  actionLoading: false,
  error: null,
}
const subjectSlice = createSlice({
  name: 'subject',
  initialState,
  reducers: {
    resetSubjects: (state: SubjectState) => {
      state.subjects = []
      state.total = 0
      state.totalPages = 0
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchSubjects.pending, (state: SubjectState) => {
      state.listLoading = true
      state.error = null
    })
    builder.addCase(fetchSubjects.rejected, (state: SubjectState, action: PayloadAction<any>) => {
      const {error} = action.payload
      state.error = error
      state.listLoading = false
    })
    builder.addCase(
      fetchSubjects.fulfilled,
      (state: SubjectState, action: PayloadAction<FetchSubjectsResponse>) => {
        state.listLoading = false
        state.error = null
        const {subjects, total, totalPages} = action.payload
        state.subjects = subjects
        state.total = total
        state.totalPages = totalPages
      }
    )
    builder.addCase(fetchAllSubjects.pending, (state: SubjectState) => {
      state.listLoading = true
      state.error = null
    })
    builder.addCase(
      fetchAllSubjects.rejected,
      (state: SubjectState, action: PayloadAction<any>) => {
        const {error} = action.payload
        state.error = error
        state.listLoading = false
      }
    )
    builder.addCase(
      fetchAllSubjects.fulfilled,
      (state: SubjectState, action: PayloadAction<FetchAllSubjectsResponse>) => {
        state.listLoading = false
        state.error = null
        const {subjects} = action.payload
        state.subjects = subjects
      }
    )

    builder.addCase(fetchSubjectById.pending, (state: SubjectState) => {
      state.listLoading = true
      state.error = null
    })
    builder.addCase(
      fetchSubjectById.rejected,
      (state: SubjectState, action: PayloadAction<any>) => {
        const {error} = action.payload
        state.error = error
        state.listLoading = false
      }
    )
    builder.addCase(
      fetchSubjectById.fulfilled,
      (state: SubjectState, action: PayloadAction<FetchSubjectByIdResponse>) => {
        state.subjectForEdit = action.payload.subject
        state.listLoading = false
        state.error = null
        state.subjectForEdit = action.payload.subject
      }
    )

    builder.addCase(createSubject.pending, (state: SubjectState) => {
      state.actionLoading = true
      state.error = null
    })
    builder.addCase(createSubject.rejected, (state: SubjectState, action: PayloadAction<any>) => {
      const {error} = action.payload
      state.error = error
      state.actionLoading = false
    })
    builder.addCase(
      createSubject.fulfilled,
      (state: SubjectState, action: PayloadAction<FetchSubjectByIdResponse>) => {
        state.subjectForEdit = action.payload.subject
        state.actionLoading = false
        state.error = null
      }
    )

    builder.addCase(updateSubject.pending, (state: SubjectState) => {
      state.actionLoading = true
      state.error = null
    })
    builder.addCase(updateSubject.rejected, (state: SubjectState, action: PayloadAction<any>) => {
      const {error} = action.payload
      state.error = error
      state.actionLoading = false
    })
    builder.addCase(
      updateSubject.fulfilled,
      (state: SubjectState, action: PayloadAction<FetchSubjectByIdResponse>) => {
        state.subjectForEdit = action.payload.subject
        state.actionLoading = false
        state.error = null
      }
    )

    builder.addCase(deleteSubject.pending, (state: SubjectState) => {
      state.actionLoading = true
      state.error = null
    })
    builder.addCase(deleteSubject.rejected, (state: SubjectState, action: PayloadAction<any>) => {
      const {error} = action.payload
      state.error = error
      state.actionLoading = false
    })
    builder.addCase(
      deleteSubject.fulfilled,
      (state: SubjectState, action: PayloadAction<FetchSubjectByIdResponse>) => {
        state.subjectForEdit = action.payload.subject
        state.actionLoading = false
        state.error = null
      }
    )

    builder.addCase(suspendSubject.pending, (state: SubjectState) => {
      state.actionLoading = true
      state.error = null
    })
    builder.addCase(suspendSubject.rejected, (state: SubjectState, action: PayloadAction<any>) => {
      const {error} = action.payload
      state.error = error
      state.actionLoading = false
    })
    builder.addCase(
      suspendSubject.fulfilled,
      (state: SubjectState, action: PayloadAction<FetchSubjectByIdResponse>) => {
        state.subjectForEdit = action.payload.subject
        state.actionLoading = false
        state.error = null
      }
    )

    builder.addCase(activateSubject.pending, (state: SubjectState) => {
      state.actionLoading = true
      state.error = null
    })
    builder.addCase(activateSubject.rejected, (state: SubjectState, action: PayloadAction<any>) => {
      const {error} = action.payload
      state.error = error
      state.actionLoading = false
    })
    builder.addCase(
      activateSubject.fulfilled,
      (state: SubjectState, action: PayloadAction<FetchSubjectByIdResponse>) => {
        state.subjectForEdit = action.payload.subject
        state.actionLoading = false
        state.error = null
      }
    )
  },
})

export default subjectSlice.reducer
export const actions = subjectSlice.actions
